import React from 'react';
import { IOldIconProps } from './type';

const EcoLeaf: React.FC<IOldIconProps> = ({ width, height, ...props }) => {
  return (
    <svg
      width={width || 60}
      height={height || 40}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      viewBox="0 0 153.071 102.047"
      enableBackground="new 0 0 153.071 102.047"
      {...props}
    >
      <g>
        <rect fill="#94C11C" width="153.07" height="102.047" />
      </g>
      <path
        fill="#FFFFFF"
        d="M59.615,23.566c1.634,0.129,2.438,0.213,4.039,0.405c0.52,0.065,1.014-0.162,1.102-0.513
        c0.28-1.075,0.422-1.617,0.694-2.703c0.09-0.354,0.353-0.32,0.575,0.076c0.704,1.212,1.049,1.824,1.718,3.053
        c0.222,0.401,0.817,0.785,1.319,0.887c1.497,0.305,2.042,0.441,3.854,0.925c0.499,0.134,0.58,0.361,0.217,0.488
        c-1.114,0.386-1.689,0.491-2.838,0.96c-0.37,0.147-0.504,0.604-0.3,1.01c0.62,1.236,0.912,1.897,1.484,3.221
        c0.19,0.434,0.01,0.481-0.399,0.118c-1.257-1.105-1.911-1.52-3.232-2.446c-0.439-0.307-1.099-0.418-1.474-0.26
        c-1.126,0.49-1.688,0.834-2.833,1.348c-0.375,0.171-0.6,0.025-0.505-0.314c0.295-1.05,0.442-1.666,0.729-2.714
        c0.092-0.342-0.205-0.853-0.662-1.123c-1.417-0.844-2.136-1.25-3.589-2.03C59.043,23.697,59.085,23.526,59.615,23.566"
      />
      <path
        fill="#FFFFFF"
        d="M43.693,35.216c1.948-0.407,2.549-0.503,4.393-0.767c0.551-0.078,1.111-0.408,1.243-0.771
        c0.401-1.123,0.59-1.679,0.983-2.785c0.128-0.356,0.398-0.374,0.6-0.043c0.636,1.042,0.948,1.567,1.562,2.63
        c0.201,0.345,0.799,0.647,1.319,0.616c1.732-0.104,2.133-0.205,3.892-0.291c0.507-0.025,0.571,0.173,0.211,0.406
        c-1.349,0.875-1.76,1.232-2.956,1.953c-0.382,0.23-0.573,0.662-0.379,1.024c0.583,1.084,0.87,1.635,1.43,2.757
        c0.187,0.369-0.015,0.471-0.447,0.228c-1.309-0.74-1.975-1.082-3.341-1.702c-0.452-0.211-1.161-0.178-1.577,0.071
        c-1.263,0.755-1.686,1.026-3.383,2.09c-0.471,0.294-0.702,0.248-0.526-0.205c0.549-1.409,0.739-1.749,1.191-2.875
        c0.147-0.366-0.138-0.803-0.614-0.949c-1.474-0.452-2.224-0.644-3.759-0.957C43.04,35.547,43.108,35.349,43.693,35.216"
      />
      <path
        fill="#FFFFFF"
        d="M35.277,49.989c1.78-0.146,2.636-0.179,4.292-0.184c0.539-0.002,1.191-0.294,1.459-0.662
        c0.835-1.132,1.246-1.692,2.064-2.802c0.264-0.357,0.519-0.344,0.572,0.032c0.152,1.161,0.227,1.749,0.351,2.932
        c0.041,0.381,0.482,0.727,0.963,0.794c1.676,0.233,1.944,0.278,3.635,0.592c0.456,0.085,0.467,0.289,0.03,0.438
        c-1.352,0.449-2.043,0.701-3.463,1.246c-0.458,0.178-0.872,0.65-0.864,1.04c0.008,1.197,0.008,1.801-0.007,3.021
        c-0.009,0.402-0.248,0.494-0.541,0.208c-0.894-0.86-1.354-1.281-2.316-2.085c-0.317-0.26-0.995-0.294-1.503-0.077
        c-1.55,0.672-2.338,1.032-3.931,1.777c-0.525,0.245-0.708,0.138-0.394-0.252c0.938-1.178,1.411-1.763,2.333-2.92
        c0.309-0.379,0.264-0.877-0.093-1.097c-1.116-0.683-1.693-0.998-2.917-1.576C34.552,50.23,34.706,50.036,35.277,49.989"
      />
      <path
        fill="#FFFFFF"
        d="M63.851,69.684c-1.169,0.667-1.809,1.104-3.051,1.977c-0.403,0.283-0.652,0.894-0.549,1.352
        c0.312,1.4,0.461,2.115,0.757,3.609c0.097,0.489-0.113,0.648-0.464,0.351c-1.067-0.915-1.602-1.351-2.673-2.193
        c-0.354-0.279-0.983-0.245-1.398,0.078c-1.264,0.974-1.899,1.478-3.183,2.51c-0.424,0.345-0.6,0.202-0.402-0.301
        c0.607-1.532,0.905-2.275,1.491-3.729c0.195-0.477,0.056-1.065-0.31-1.311c-1.116-0.749-1.682-1.108-2.819-1.789
        c-0.371-0.22-0.273-0.448,0.21-0.513c1.503-0.19,2.246-0.265,3.72-0.383c0.479-0.04,1.02-0.434,1.198-0.874
        c0.564-1.379,0.842-2.052,1.379-3.346c0.175-0.424,0.41-0.427,0.522-0.02c0.344,1.26,0.513,1.901,0.85,3.221
        c0.107,0.428,0.581,0.771,1.044,0.763c1.44-0.031,2.16-0.062,3.559,0.103C64.187,69.235,64.229,69.47,63.851,69.684"
      />
      <path
        fill="#FFFFFF"
        d="M83.057,71.851c-1.026,0.337-1.54,0.52-2.58,0.894c-0.341,0.121-0.498,0.563-0.348,0.981
        c0.455,1.266,0.689,1.898,1.168,3.168c0.16,0.417-0.015,0.493-0.389,0.162c-1.126-0.997-1.68-1.506-2.771-2.535
        c-0.364-0.339-0.937-0.503-1.286-0.354c-1.057,0.445-1.593,0.68-2.682,1.189c-0.361,0.169-0.543-0.008-0.409-0.39
        c0.421-1.152,0.623-1.706,1.022-2.794c0.132-0.36-0.05-0.929-0.399-1.271c-1.067-1.062-1.595-1.597-2.645-2.659
        c-0.337-0.346-0.27-0.521,0.152-0.388c1.306,0.412,1.959,0.619,3.26,1.04c0.419,0.138,0.863-0.028,0.987-0.359
        c0.381-1.033,0.568-1.532,0.935-2.519c0.117-0.314,0.322-0.242,0.456,0.166c0.416,1.255,0.627,1.886,1.057,3.157
        c0.139,0.41,0.598,0.862,1.021,0.997c1.311,0.431,1.961,0.643,3.275,1.068C83.307,71.543,83.386,71.74,83.057,71.851"
      />
      <path
        fill="#FFFFFF"
        d="M100.293,66.757c-1.149,0.439-1.684,0.669-2.796,1.103c-0.358,0.139-0.497,0.579-0.3,0.983
        c0.588,1.221,0.891,1.831,1.518,3.034c0.202,0.391,0.02,0.478-0.41,0.172c-1.305-0.926-1.944-1.39-3.182-2.504
        c-0.408-0.366-1.021-0.582-1.373-0.469c-1.06,0.337-1.589,0.502-2.643,0.848c-0.35,0.113-0.55-0.076-0.45-0.419
        c0.319-1.041,0.478-1.554,0.794-2.57c0.111-0.339-0.128-0.91-0.51-1.285c-1.193-1.16-1.781-1.757-2.933-2.928
        c-0.374-0.385-0.319-0.545,0.126-0.366c1.369,0.563,2.051,0.838,3.438,1.367c0.449,0.175,0.91,0.047,1.016-0.276
        c0.332-1.018,0.504-1.521,0.85-2.529c0.111-0.328,0.332-0.24,0.498,0.183c0.508,1.32,0.771,1.982,1.309,3.3
        c0.178,0.428,0.693,0.9,1.163,1.06c1.434,0.482,2.183,0.565,3.677,0.87C100.566,66.421,100.658,66.613,100.293,66.757"
      />
      <path
        fill="#FFFFFF"
        d="M111.537,55.311c-1.096,0.763-1.635,1.116-2.699,1.765c-0.338,0.21-0.492,0.642-0.338,0.959
        c0.478,0.968,0.721,1.443,1.21,2.378c0.167,0.312-0.009,0.398-0.38,0.197c-1.123-0.603-1.674-0.932-2.758-1.633
        c-0.359-0.231-0.912-0.303-1.238-0.156c-0.985,0.448-1.469,0.657-2.427,1.067c-0.317,0.136-0.49,0.004-0.387-0.289
        c0.306-0.893,0.464-1.338,0.785-2.24c0.104-0.296-0.086-0.754-0.433-1.02c-1.047-0.827-1.557-1.313-2.572-2.203
        c-0.33-0.288-0.277-0.437,0.123-0.346c1.225,0.303,1.844,0.437,3.107,0.652c0.414,0.067,0.842-0.155,0.954-0.493
        c0.353-1.05,0.533-1.581,0.898-2.676c0.122-0.349,0.329-0.331,0.464,0.04c0.422,1.158,0.648,1.733,1.084,2.88
        c0.141,0.37,0.607,0.703,1.037,0.722c1.333,0.061,2.008,0.065,3.396-0.011C111.812,54.883,111.887,55.06,111.537,55.311"
      />
      <path
        fill="#FFFFFF"
        d="M120.664,37.964c-1.053,1.102-1.582,1.645-2.633,2.692c-0.339,0.334-0.521,0.859-0.408,1.166
        c0.355,0.923,0.536,1.378,0.916,2.264c0.121,0.287-0.049,0.464-0.385,0.381c-1.022-0.247-1.52-0.396-2.49-0.748
        c-0.316-0.116-0.849,0.041-1.178,0.348c-1.008,0.928-1.537,1.382-2.471,2.205c-0.303,0.269-0.459,0.188-0.35-0.166
        c0.336-1.092,0.602-1.681,1.01-2.831c0.138-0.381-0.002-0.81-0.307-0.954c-0.934-0.459-1.389-0.713-2.291-1.242
        c-0.291-0.171-0.225-0.356,0.149-0.415c1.164-0.188,1.751-0.303,2.948-0.587c0.387-0.096,0.82-0.503,0.961-0.896
        c0.43-1.229,0.643-1.849,1.083-3.11c0.138-0.412,0.337-0.473,0.436-0.134c0.304,1.048,0.464,1.56,0.786,2.563
        c0.105,0.322,0.525,0.477,0.927,0.34c1.249-0.434,1.884-0.672,3.161-1.208C120.946,37.465,121.008,37.611,120.664,37.964"
      />
      <path
        fill="#FFFFFF"
        d="M100.818,26.535c1.08,0.093,1.498,0.066,2.763,0.024c0.368-0.013,0.749-0.329,0.851-0.716
        c0.313-1.194,0.475-1.812,0.799-3.092c0.105-0.412,0.292-0.436,0.412-0.054c0.373,1.188,0.561,1.755,0.938,2.873
        c0.121,0.358,0.52,0.583,0.895,0.583c1.008,0,1.648-0.032,2.912-0.096c0.38-0.02,0.465,0.131,0.138,0.389
        c-0.929,0.73-1.408,0.981-2.317,1.707c-0.311,0.248-0.431,0.762-0.307,1.1c0.379,1.02,0.57,1.52,0.958,2.498
        c0.128,0.323-0.017,0.446-0.324,0.283c-0.931-0.501-1.394-0.761-2.317-1.31c-0.304-0.18-0.787-0.128-1.072,0.107
        c-0.861,0.721-1.287,1.067-2.131,1.718c-0.274,0.21-0.426,0.087-0.336-0.238c0.273-0.978,0.412-1.497,0.703-2.568
        c0.096-0.351-0.083-0.788-0.376-0.998c-0.944-0.677-1.388-1.059-2.294-1.817C100.414,26.68,100.463,26.504,100.818,26.535"
      />
      <path
        fill="#FFFFFF"
        d="M80.803,22.676c1.271,0.364,1.902,0.547,3.158,0.915c0.414,0.116,0.836-0.052,0.943-0.372
        c0.344-1.006,0.515-1.521,0.871-2.584c0.113-0.338,0.328-0.293,0.467,0.113c0.432,1.259,0.639,1.889,1.053,3.136
        c0.131,0.403,0.569,0.827,0.975,0.946c1.263,0.366,1.886,0.542,3.145,0.898c0.408,0.117,0.469,0.322,0.134,0.463
        c-1.027,0.424-1.526,0.622-2.525,0.996c-0.323,0.121-0.481,0.54-0.358,0.937c0.381,1.205,0.564,1.798,0.938,2.978
        c0.121,0.386-0.04,0.443-0.356,0.116c-0.955-0.979-1.44-1.473-2.419-2.452c-0.32-0.321-0.845-0.495-1.155-0.389
        c-0.948,0.321-1.414,0.474-2.346,0.761c-0.303,0.099-0.473-0.063-0.369-0.356c0.312-0.887,0.475-1.335,0.793-2.257
        c0.105-0.303-0.081-0.812-0.414-1.125c-1.039-0.97-1.57-1.449-2.643-2.383C80.344,22.708,80.394,22.561,80.803,22.676"
      />
      <path
        fill="#FFFFFF"
        d="M130.557,21.923c-0.924,0.842-1.409,1.277-2.399,2.185c-0.323,0.295-0.502,0.747-0.392,0.994
        c0.34,0.754,0.516,1.117,0.891,1.813c0.125,0.227-0.043,0.387-0.373,0.348c-0.994-0.111-1.48-0.193-2.441-0.384
        c-0.316-0.063-0.848,0.136-1.189,0.449c-1.032,0.947-1.555,1.428-2.609,2.383c-0.346,0.309-0.506,0.272-0.355-0.09
        c0.463-1.095,0.695-1.647,1.148-2.743c0.153-0.358,0.027-0.729-0.276-0.826c-0.934-0.285-1.388-0.451-2.294-0.811
        c-0.291-0.117-0.213-0.305,0.182-0.419c1.203-0.342,1.807-0.525,3.012-0.899c0.391-0.122,0.827-0.521,0.979-0.882
        c0.455-1.128,0.688-1.688,1.135-2.815c0.15-0.363,0.334-0.411,0.418-0.11c0.255,0.915,0.392,1.357,0.684,2.213
        c0.095,0.276,0.482,0.392,0.865,0.272c1.18-0.391,1.762-0.582,2.895-0.948C130.801,21.533,130.856,21.655,130.557,21.923"
      />
      <path
        fill="#FFFFFF"
        d="M89.733,41.942c0.675-0.181,0.771-0.524-0.027-0.482c-1.368,0.068-17.307,3.737-31.122,11.796
        c-15.032,8.77-19.576,13.138-22.786,15.626c-0.85,0.658-1.478,0.669-1.628,0.267c-0.513-1.367-0.834-2.146-1.252-3.428
        c-0.127-0.391-0.497-0.347-0.662,0.198c-0.563,1.856-0.832,2.989-1.38,4.664c-0.174,0.537-0.358,1.126-1.355,1.82
        c-1.973,1.373-2.383,1.641-3.613,2.479c-0.447,0.304-0.678,0.638,0.213,0.799c0.856,0.155,1.026,0.188,2.183,0.4
        c0.923,0.17,0.619,0.795,0.487,1.339c-0.375,1.554-0.536,2.179-1.036,3.776c-0.169,0.524,0.047,0.592,0.475,0.146
        c1.313-1.372,1.74-1.834,3.125-3.278c0.523-0.545,1.012-1.169,1.56-1.07c1.355,0.244,1.518,0.285,3.417,0.645
        c0.842,0.159,0.837-0.229,0.613-0.782c-0.65-1.61-0.53-1.398-1.023-2.761c-0.158-0.436-0.186-1.249,0.307-1.729
        c7.92-7.706,11.198-10.223,22.084-17.322C66.839,49.482,78.172,45.064,89.733,41.942z"
      />
    </svg>
  );
};

export default EcoLeaf;
